import classNames from "classnames";
import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { OptionData } from "components/DesignSystem/Combobox/Combobox";
import SmallPencil from "components/icons/SmallPencil";
import React from "react";
import { components, OptionProps } from "react-select";

export const ShareholderOption = ({
  children,
  onEdit,
  ...props
}: OptionProps<OptionData> & {
  onEdit: (shareholderId: string) => void;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (props.isDisabled || props.data.disableOption) {
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <div className="t-w-full t-flex t-justify-between t-items-center">
      <components.Option
        {...props}
        isDisabled={props.isDisabled || Boolean(props.data.disableOption)}
        className="[&.select\_\_option--is-disabled]:t-text-subtitle-sm [&.select\_\_option--is-disabled]:t-text-text-100 [&.select\_\_option--is-disabled]:t-cursor-not-allowed [&.select\_\_option--is-disabled]:t-opacity-50 t-w-fit"
        getStyles={() => ({
          paddingLeft: props.data.indent
            ? `${props.data.indent * 1.5}rem`
            : "0",
        })}
      >
        <div
          className={classNames(
            "t-truncate !t-border-none t-px-3 t-py-2.5 t-font-medium t-flex t-gap-2.5",
            {
              "t-cursor-not-allowed":
                props.isDisabled || props.data.disableOption,
              "t-cursor-pointer ":
                !props.isDisabled && !props.data.disableOption,
            }
          )}
          aria-label={props.data.value}
          aria-selected={props.isSelected}
          role="option"
          onClick={handleClick}
        >
          {props.isMulti && (
            <Checkbox
              name={props.data.value}
              checked={props.isSelected}
              disabled={props.isDisabled || props.data.disableOption}
            />
          )}
          {children}
        </div>
      </components.Option>
      <button
        className="all:unset t-w-fit t-mr-4 t-text-purple"
        onClick={() => onEdit(props.data.value)}
      >
        <SmallPencil color="#5622ff" />
      </button>
    </div>
  );
};
